<template>
  <v-card flat>
    <v-card-title class="pt-0 px-0">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-bind="attrs"
            v-on="on"
            @click="modal = true"
          >
            {{ mdiTable }}
          </v-icon>
        </template>
        <span>Open tension beats table</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-bind="attrs"
            v-on="on"
            @click="chart = true"
          >
            {{ mdiChartBar }}
          </v-icon>
        </template>
        <span>Open tension beats chart</span>
      </v-tooltip>
    </v-card-title>
    <v-card-text v-if="loading" class="text-center">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      />
    </v-card-text>
    <v-card-text class="pa-0" v-else>
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th></th>
              <th class="text-left">
                Avg per Session
              </th>
              <th class="text-left">
                Total
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="items.length === 0">
              <td class="text-center caption" colspan="3">No data</td>
            </tr>
            <template v-else>
              <tr
                v-for="item in items"
                :key="item.name"
              >
                <td class="caption">{{ item.name }}</td>
                <td class="caption">{{ timeToString((item.val  * 1000) / (item.players || 1)) }}</td>
                <td class="caption">{{ timeToString(item.val * 1000) }}</td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
    <equiped-weapons-by-tension-beats-modal
      v-if="modal"
      @close="modal = false"
    />
    <equiped-weapons-chart-by-tension-beats
      v-if="chart"
      @close="chart = false"
    />
  </v-card>
</template>

<script>
import helper from '../../../plugins/helpers/mixin-helper'
import { mdiTable, mdiChartBar } from '@mdi/js';
export default {
  mixins: [
    helper
  ],
  components: { 
    equipedWeaponsByTensionBeatsModal: () => import('./equipedWeaponsByTensionBeatsModal.vue'),
    equipedWeaponsChartByTensionBeats: () => import('./equipedWeaponsChartByTensionBeats.vue')
  },
  data () {
    return {
      mdiTable,
      mdiChartBar,
      loading: true,
      modal: false,
      chart: false,
      items: []
    }
  },
  watch: {
    async '$route.params' () {
      await this.getData()
    }
  },
  async mounted () {
    await this.getData()
  },
  methods: {
    async getData () {
      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/marketing/telemetry/global-equiped-weapon`, {
          params: {
            build_tag: this.$route.params.buildTag
          }
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.items = data
      }
      this.loading = false
    }
  }
}
</script>